module.exports = __webpack_public_path__ + "assets/9909d25cfdeaf92017dd129e0977fa90.png";